export default __webpack_public_path__ + "static/media/think1.6a0492e0.png";